import { IsEnum, IsOptional, IsUUID } from 'class-validator';
import { ViewType } from '../../enums/view-type.enum';

export class TrackViewDto {
	@IsEnum(ViewType)
	type: ViewType;

	@IsUUID()
	targetUserId: string;

	@IsOptional()
	@IsUUID()
	eventId?: string;
}
